import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('experiment')

export const SET_LOADED = makeConstant('SET_LOADED')
export const TIMED_OUT = makeConstant('TIMED_OUT')

export const UserFeature = Object.freeze({
  ICP_ONBOARDING_STEP: 'icp-onboarding-step',
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/experiment/constants.js